import { ProgrammingLanguageKey } from "@hub/data/values/data-keys.enum";
import { DocumentCardData } from "@hub/models/document/document-card-data";
import React from "react";
import { AnchorLink } from "../anchor-link";
import { BracketsIcon } from "../icons/brackets-icon";
import { DocumentCardHeadline } from "./document-card-headline";
import { DocumentCardIcon } from "./document-card-icon";
import styles from "./document-card.module.css";

interface DocumentCardProps {
  data: DocumentCardData;
  openNewTab?: boolean;
  testName?: string;
  withTopBorder?: boolean;
}

export const DocumentCard: React.FC<DocumentCardProps> = ({
  data,
  testName,
  withTopBorder = false,
  openNewTab,
}) => {
  const {
    title,
    description,
    icons,
    path,
    languages,
    framework,
    newTab,
    hasRabbit,
  } = data;

  let search: string | null = null;
  let newSearch: string | null = ``;

  if (typeof window !== "undefined") {
    const params: { [index: string]: any } = {};
    search = window.location.search;

    const decodedSearch = decodeURIComponent(search);

    decodedSearch
      .replace(/\?/g, "")
      .split("&")
      .map((element) => {
        const [key, values] = element.split("=");
        if (key && values) {
          const valueElements = values ? values.split(",") : [];

          if (key === "framework") {
            params[key] = valueElements.filter(
              (valueElement) => valueElement === framework
            );
          }

          if (key === "language") {
            params[key] = valueElements.filter(
              (valueElement) =>
                languages.indexOf(valueElement as ProgrammingLanguageKey) > -1
            );
          }
        }
      });

    const entries = Object.entries(params);

    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];

      if (!entry) {
        continue;
      }

      const [key, values] = entry;

      if (i === 0) {
        newSearch = `?${newSearch}${key}=${values.join(",")}`;
        continue;
      }

      if (i < entries.length - 1) {
        newSearch = `${newSearch}${key}=${values.join(",")}&`;
        continue;
      }

      newSearch = `${newSearch}${key}=${values.join(",")}`;
    }
  }

  let openInNewTab = false;

  if (openNewTab !== undefined) {
    openInNewTab = openNewTab;
  }

  if (openNewTab === undefined && newTab !== null && newTab !== undefined) {
    openInNewTab = newTab;
  }

  return (
    <AnchorLink
      testName={testName}
      to={path}
      // to={`${path}${newSearch ? newSearch : ""}`}
      openNewTab={openInNewTab}
      className={`${styles.documentCard}${
        withTopBorder ? ` ${styles.documentCard_withTopBorder}` : ""
      }`}
    >
      <div className={styles.mediaBar}>
        <div className={styles.mediaBar__icons}>
          <DocumentCardIcon
            src={icons.framework.src}
            alt={icons.framework.alt}
          />
          {icons.languages &&
            icons.languages.map((icon) => (
              <DocumentCardIcon key={icon.src} src={icon.src} alt={icon.alt} />
            ))}
        </div>
      </div>
      <DocumentCardHeadline
        title={title}
        description={description}
        hasRabbit={hasRabbit}
      />
      <div className={styles.documentCard__button}>
        <BracketsIcon />
      </div>
    </AnchorLink>
  );
};
